var map = {
	"./account.svg": 7650,
	"./admin.svg": 5033,
	"./amount-selected.svg": 332,
	"./amount.svg": 3359,
	"./amount0.svg": 706,
	"./amount1.svg": 4875,
	"./amount2.svg": 2949,
	"./amount3.svg": 1288,
	"./amount4.svg": 9488,
	"./amount5.svg": 9861,
	"./amount6.svg": 8989,
	"./article-create.svg": 168,
	"./article-ranking.svg": 7796,
	"./article.svg": 6178,
	"./auth.svg": 265,
	"./board.svg": 1482,
	"./building.svg": 6017,
	"./car-info.svg": 9370,
	"./car-insurance.svg": 2676,
	"./cfo.svg": 9430,
	"./change-theme.svg": 2909,
	"./chart.svg": 5768,
	"./close.svg": 7766,
	"./common_file.svg": 931,
	"./config.svg": 3499,
	"./cx.svg": 1,
	"./dashboard.svg": 1470,
	"./database.svg": 2063,
	"./example.svg": 1047,
	"./exit-fullscreen.svg": 1209,
	"./eye-open.svg": 3345,
	"./eye.svg": 6177,
	"./fcx.svg": 3581,
	"./fullscreen.svg": 379,
	"./goods.svg": 6771,
	"./guide.svg": 1150,
	"./hamburger-closed.svg": 3666,
	"./hamburger-opened.svg": 8590,
	"./home.svg": 5854,
	"./hsgt.svg": 195,
	"./hsgt_lgt.svg": 8937,
	"./info.svg": 3342,
	"./insurance.svg": 2606,
	"./insurance_info.svg": 5537,
	"./international.svg": 1491,
	"./introduce.svg": 5470,
	"./invoice.svg": 8263,
	"./language.svg": 9141,
	"./ling.svg": 9276,
	"./link.svg": 6248,
	"./list.svg": 760,
	"./lock.svg": 1394,
	"./log.svg": 1483,
	"./logo.svg": 852,
	"./logo1.svg": 7523,
	"./manager.svg": 5298,
	"./mark.svg": 6021,
	"./mini_app.svg": 8771,
	"./minus.svg": 6356,
	"./money.svg": 138,
	"./nested.svg": 7238,
	"./online.svg": 3125,
	"./original.svg": 7614,
	"./other.svg": 5752,
	"./password.svg": 441,
	"./permission.svg": 1172,
	"./personnel-info.svg": 4029,
	"./personnel-manage.svg": 6863,
	"./personnel.svg": 9440,
	"./phone-signature.svg": 9857,
	"./plus.svg": 9752,
	"./pre.svg": 9170,
	"./project.svg": 5115,
	"./register-check.svg": 1108,
	"./reward.svg": 8285,
	"./role-group.svg": 9095,
	"./role.svg": 3845,
	"./search.svg": 8115,
	"./shareholders.svg": 2863,
	"./signature.svg": 6041,
	"./some.svg": 6653,
	"./table.svg": 8637,
	"./team.svg": 6923,
	"./total.svg": 2117,
	"./tree.svg": 6012,
	"./user.svg": 387,
	"./video.svg": 6243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;